import { render, staticRenderFns } from "./CandidatesDetail.vue?vue&type=template&id=f3fdb14a&scoped=true"
import script from "./candidatesDetail.ts?vue&type=script&lang=ts&external"
export * from "./candidatesDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./CandidatesDetail.vue?vue&type=style&index=0&id=f3fdb14a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fdb14a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3fdb14a')) {
      api.createRecord('f3fdb14a', component.options)
    } else {
      api.reload('f3fdb14a', component.options)
    }
    module.hot.accept("./CandidatesDetail.vue?vue&type=template&id=f3fdb14a&scoped=true", function () {
      api.rerender('f3fdb14a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/client/candidates/candidates-detail/CandidatesDetail.vue"
export default component.exports